export const API_GATEWAY_URL = new URL(import.meta.env.VITE_NLA_CONTENT_API_GATEWAY);
export const ENABLE_ARTICLE_VIEWER = import.meta.env.VITE_ENABLE_ARTICLE_VIEWER?.toLowerCase() === "true";
